import { Spinner } from '@crm/ui';
import { Navigate, useLocation } from 'react-router-dom';
import { AUTH_ROUTES } from '@/modules/auth/constants';
import { useSession } from '@/modules/auth/hooks';

/** Bloqueia rotas privadas enquanto nao houver sessao valida. */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={AUTH_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/** Impede que um usuario ja autenticado volte para registro/recuperacao de senha. */
export function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  // O /login fica de fora dessa trava: quem tem wizard de cadastro pendente
  // cairia direto de volta nele (via HomeRoute) e nunca conseguiria nem ver
  // a tela de login.
  if (isAuthenticated && location.pathname !== AUTH_ROUTES.LOGIN) {
    return <Navigate to={AUTH_ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
